import { config } from 'global/lib/config'
import productLib from 'global/lib/product/product'
import userDataLib from 'global/lib/userData/userData'
import { reduxStore } from 'global/lib/reduxStore'

import { setCurrentAccessToken, setCurrentBccAccount } from 'global/redux/features/accessToken/accessTokenSlice'

export default async function validateAppForAccessToken(accessTokenId: string, cb?: any) {
  if (productLib.hasSentinelProduct(accessTokenId) || productLib.hasForensicsProduct(accessTokenId)) {
    let newHref = `${config.domains.sentinel}/report/${accessTokenId}/dashboard`

    if (config.isDev) {
      newHref = newHref.replace('3005', window.location.port)
    }

    window.location.replace(newHref)
  } else if (cb) {
    const token = userDataLib.getAccountByAccessToken(accessTokenId as string)

    if (token) {
      await reduxStore.dispatch(setCurrentBccAccount(token.bccId))
    }

    await reduxStore.dispatch(setCurrentAccessToken(accessTokenId))
    cb(true)
  }
}
